// What a post being written is made of, shared by the full composer screen and
// the dashboard's quick composer.

import type { MediaFacts } from "../lib/media";
import type { MediaAsset } from "../lib/types";

export type Stage =
  | "idle" | "uploading-media" | "creating" | "uploading-youtube" | "dispatching" | "done";

/**
 * Instagram's carousel limit [C036], and so the product's — `create_post`
 * refuses an eleventh item, and a screen that let somebody choose one would be
 * promising something the database will not do.
 */
export const MAX_PHOTOS = 10;

/**
 * One file in the post being written.
 *
 * Exactly one of `file` and `asset` is ever set:
 *   file  — just picked from disk, bytes in memory, not uploaded yet
 *   asset — already in the library, bytes already in storage
 * `facts` is filled from whichever it is, because validation needs the same
 * five numbers either way.
 */
export interface ComposeItem {
  /** Stable across reorders, which is what React needs and an index is not. */
  key: string;
  file: File | null;
  asset: MediaAsset | null;
  facts: MediaFacts;
  previewUrl: string | null;
}

let itemSeq = 0;
export const nextKey = () => `item-${++itemSeq}`;

/** Only a blob: URL is ours to revoke; a signed storage URL is not. */
export function releasePreview(item: ComposeItem) {
  if (item.previewUrl?.startsWith("blob:")) URL.revokeObjectURL(item.previewUrl);
}
